import { ChordSteps } from "../../../Comps/ChordSteps/ChordSteps";
import { Helper } from "../../../Comps/HelperSelector/HelperSelector";
import { HexPlayer, HexPlayerModes } from "../../../Comps/HexPlayer/HexPlayer";
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox";
import { Music } from "../../../Util/Music/Music";
import { ChapterConfig } from "../../ChapterConfig";
import { useSetOpenHelpers } from "../../CourseStore";
import { ChordBuilderExercise } from "../../Exercises/ChordBuilderExercise/ChordBuilderExercise";
import { ChordShapeExercise } from "../../Exercises/ChordShapeExercise/ChordShapeExercise";
import { ChordTypeExercise } from "../../Exercises/ChordTypeExercise/ChordTypeExercise";
import { ClearHelpers } from "../../Helpers/ClearHelpers/ClearHelpers";
import { Helpers } from "../../Helpers/Helpers";
import { ChapterNav, ChapterNavItem } from "../ChapterNav/ChapterNav";
import { ChapterRoutes } from "../ChapterNav/ChapterRoutes";

export function DiatonicChordsChapter(props:ChapterConfig){
    const subPaths:ChapterNavItem[] = [
        {title:'Lesson', path:'lesson', 
            element:<ClearHelpers key={0} openHelpers={[Helpers.HexPattern, Helpers.ChordTypes, Helpers.ChordShapes]}>
                        <Lesson/>
                    </ClearHelpers>},
        {title:'Chord Builder Exercise', path:'chord_builder', 
            isExercise:true, 
            element:<ClearHelpers openHelpers={[Helpers.HexPattern, Helpers.ChordTypes]} key={1} >
                        <ChordBuilderExercise/>
                    </ClearHelpers>},
            {title:'Chord Type Exercise', path:'chord_types',  
            isExercise:true,
            element:<ClearHelpers openHelpers={[Helpers.ChordTypes]} key={2} >
                        <ChordTypeExercise/>
                    </ClearHelpers>},
        {title:'Chord Shape Memorizer', path:'chord_shapes', 
            isExercise:true, 
            element:<ClearHelpers key={3} >
                        <ChordShapeExercise/>
                    </ClearHelpers>},
        {title:'Chord Player', path:'chord_player', 
            element:<ClearHelpers key={4} >
                        <OutlineBox width={800} title={'ChordPlayer'}>
                            <HexPlayer tonic={Music.C} playMode={HexPlayerModes.Chords}/>
                        </OutlineBox>
                    </ClearHelpers>}
    ]
    return  <div>
                <h1>Building Diatonic Chords</h1>
                <ChapterNav path={props.path} subPaths={subPaths}/>
                <ChapterRoutes chapterNavs={subPaths}/>
            </div>
}

export function Lesson(){
    useSetOpenHelpers([Helper.HEX_PATTERN, Helper.CHORD_TYPE, Helper.CHORD_SHAPES])
    return(
                <OutlineBox title={'Building Diatonic Chords'} width={600}>
                    <div className={'BuildingDiatonicChords Lesson'}>
                        <ChordSteps tonic={Music.G}/>
                    </div>
                </OutlineBox>
    )
}
export function Resources(){
    return <div>Chord Resources body</div>
}